import { api } from "@/builders/axios";

export function verify_otp(data: {
  email: string;
  otp: string;
  staff_id?: string;
}) {
  return api
    .post<{
      message: string;
      access_token?: string;
      data?: {
        staff_id: string;
        first_name: string;
        last_name: string;
        department: string;
        career_path: string;
        phone_number: string;
        location: string;
      };
    }>("/auth/signup/verify-otp", data)
    .then(({ data }) => data);
}
